module.exports = __webpack_public_path__ + "img/home-prize-0.c82dcb3b.png";